import { render, staticRenderFns } from "./code_dropdown_ide_item.vue?vue&type=template&id=2dd7d6b6"
import script from "./code_dropdown_ide_item.vue?vue&type=script&lang=js"
export * from "./code_dropdown_ide_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports